import { apiGet, apiPost } from "../api";

const URL_BASE = "/pendencia";
const PendenciaService = {
  listar: async (params) => await apiGet(`${URL_BASE}/listar/`, params),
  incluir: async (payload) => await apiPost(`${URL_BASE}/incluir/`, payload),
};

export default PendenciaService;
